import React, {Component} from 'react'
import {Col, Row} from "react-bootstrap";
import '@brainhubeu/react-carousel/lib/style.css';
import * as PropTypes from "prop-types";
import MainCard from "./MainCard";


/**
 * The component that displays scouting invites.
 */
class Messages extends MainCard {
    /**
     * Render ScoutingInvitesRow components from data object.
     * @returns {React.ReactNode} The ScoutingInvitesRow components.
     */
    renderItemsFromData = () => {
        return this.props.data.map((rowData, index) => (
            // Mapping object data to children components.
            <MessagesRow key={index} name={rowData.name} description={rowData.description} avatar={rowData.avatar} datetime={rowData.datetime} detailsLink={rowData.detailsLink} badge={rowData.badge}/>
        ));
    };

    static propTypes = {
        // The text that will appear in the header.
        title: PropTypes.string.isRequired,
        // The text that will appear in the footer.
        footerText: PropTypes.string,
        // The link of see more page.
        footerLink: PropTypes.string,

        badge: PropTypes.bool,
    };
    static defaultProps = {
        title: "Messages",
        footerText: "All Messages",
        footerLink: "#",
        badge: false,
    };
}

/**
 * The row component of ScoutingInvites.
 */
class MessagesRow extends Component {
    render = () => {
        const {avatar, name, description, datetime, detailsText, detailsLink, badge} = this.props;
        return (
            // TODO: Change props and classes name.
            <Row className="messages-row">
                <Col sm="auto" className="player-avatar-container left-side">
                    <img className="player-avatar rounded-circle" src={avatar} alt={name + " avatar"}/>
                    {badge && <div className="badge"/>}
                </Col>

                <Col className="info-container">
                    <span className="info-1"> {name} </span>
                    <span className="info-2"> {description} </span>
                </Col>

                <Col sm="auto" className="datetime-view-details-container right-side">
                    <div className="datetime-value">{datetime}</div>
                    <div className="view-details">
                        <a href={detailsLink}> {detailsText} </a>
                    </div>
                </Col>
            </Row>
        );
    };

    static propTypes = {
        // The profile image of the player.
        avatar: PropTypes.string.isRequired,
        // The name of the player.
        name: PropTypes.string.isRequired,
        // The description of the player.
        description: PropTypes.string.isRequired,
        // The data and time of the event.
        datetime: PropTypes.string.isRequired,
        // The link of player details page.
        detailsLink: PropTypes.string,
    };
    static defaultProps = {
        detailsLink: "#",
        detailsText: "Reply"
    };
}


export {Messages, MessagesRow};
